const DEFAULT_WHITE_LIST = ['dashboard.beta.branch.io', 'localhost'];
export class ApplicationVersionService {
    constructor(url) {
        this.url = url;
        this.isLocationWhiteListed = () => DEFAULT_WHITE_LIST.some((entry) => this.url && this.url.indexOf(entry) > -1);
    }
}
//# sourceMappingURL=ApplicationVersionService.js.map